// extracted by mini-css-extract-plugin
export default {"app":"app_app__dqqiB","container":"app_container__PN-K3"};